module.exports = __webpack_public_path__ + "img/symbol_9.854c0adf.png";